<template>
  <div class="header">
    <a-row type="flex" justify="space-between" align="middle">
      <a-col class="logo">
        <img src="@assets/logo.png" alt="">
      </a-col>
      <a-col class="menu">
        <a-menu mode="horizontal">
          <a-menu-item key="home">
            <router-link to="home">首页</router-link>
          </a-menu-item>
          <a-menu-item key="course">
            <router-link to="course">课程体系</router-link>
          </a-menu-item>
          <a-menu-item key="teach">
            <router-link to="plantform">教学平台</router-link>
          </a-menu-item>
          <a-menu-item key="matchNews">
            <router-link to="matchNews">赛考资讯</router-link>
          </a-menu-item>
          <a-menu-item key="growup">
            <router-link to="growup">成长学院</router-link>
          </a-menu-item>
          <a-menu-item key="school">
            <router-link to="school">高校合作</router-link>
          </a-menu-item>
        </a-menu>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      current: ['home']
    }
  }
};
</script>

<style scoped lang="less">
.header {
  height: 78px;
  .ant-row-flex{
    height: 100%;
  }
}

.menu {
  .ant-menu {
    font-size: 19px;
  }

  .ant-menu-horizontal {
    border-bottom: unset;
  }
}
</style>